import styled, { css } from 'styled-components'

export const PaymentContainer = styled.div`
  background-color: #ffffff;
  position: relative;
  width: 33.33%;
  min-height: 100vh;
  overflow-y: auto;

  @media (max-width: 990px) {
    width: 100%;
    height: inherit;
  }
`

export const PaymentBody = styled.div`
  padding: 16px 15px 90px;
`

export const SectionTitle = styled.h1`
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: #404040;
  text-align: center;
`

export const SectionHint = styled.p`
  margin: 6px 0 0;
  font-size: 13px;
  font-weight: 400;
  color: #8a8a8a;
  text-align: center;
  line-height: 1.4;
`

export const AmountBlock = styled.div`
  margin: 18px 0 8px;
  padding: 14px 16px;
  background: #faf7f4;
  border: 1px solid #f0e8e0;
  border-radius: 10px;
  text-align: center;

  .label {
    font-size: 12px;
    color: #8a7a6a;
    margin-bottom: 4px;
  }

  .value {
    font-size: 26px;
    font-weight: 700;
    color: ${({ theme }) => theme?.colors?.primaryButtCol || '#9c5a2e'};
    letter-spacing: 0.02em;
    display: flex;
    align-items: baseline;
    justify-content: center;
    gap: 6px;
  }

  .currency {
    font-size: 14px;
    font-weight: 600;
    opacity: 0.85;
  }
`

export const MethodsSection = styled.div`
  padding: 12px 0 0;
`

export const MethodsTitle = styled.div`
  font-size: 14px;
  font-weight: 700;
  color: #404040;
  margin-bottom: 10px;
`

export const MethodsList = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
`

export const MethodItem = styled.button`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 12px;
  width: 100%;
  min-height: 64px;
  padding: 14px 14px;
  border-radius: 10px;
  border: 1.5px solid #e7e7e7;
  background: #fff;
  cursor: pointer;
  text-align: start;
  font-family: inherit;
  transition: border-color 0.15s ease, background-color 0.15s ease, box-shadow 0.15s ease;

  ${({ active, theme }) =>
    active
      ? css`
          border-color: ${theme?.colors?.primaryButtCol || '#9c5a2e'};
          background: #faf7f4;
          box-shadow: 0 0 0 1px ${theme?.colors?.primaryButtCol || '#9c5a2e'};
        `
      : css`
          &:hover {
            border-color: #d4c4b4;
          }
        `}
`

export const MethodIcons = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-width: ${({ $brand }) => ($brand ? '64px' : '52px')};
  min-height: ${({ $brand }) => ($brand ? '36px' : '32px')};
  flex-shrink: 0;

  img {
    height: ${({ $brand }) => ($brand ? '34px' : '28px')};
    width: auto;
    max-width: ${({ $brand }) => ($brand ? '80px' : '56px')};
    object-fit: contain;
  }
`

export const MethodName = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #404040;
  line-height: 1.25;
`

export const PaymentConfigNotice = styled.p`
  color: #9e0823;
  font-size: 13px;
  margin: 14px 0 0;
  text-align: center;
  line-height: 1.4;
`
